import React from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import Select from "react-select";

interface OptionType {
    value: string;
    label: string;
}

interface ParticipantElementsFilterProps {
    show: boolean;
    onHide: () => void;
    caseworkerOptions: OptionType[];
    selectedCaseworkerIds: string[];
    onCaseworkerChange: (val: string[]) => void;
    waiverOptions: OptionType[];
    selectedWaiverIds: string[];
    onWaiverChange: (val: string[]) => void;
    regionOptions: OptionType[];
    selectedRegionId: number | null;
    onRegionChange: (val: string) => void;
    selectedEmailLinked: string;
    onEmailLinkedChange: (val: string) => void;
    onReset: () => void;
    onApply: () => void; // Added onApply prop
}

const ParticipantElementsFilter: React.FC<ParticipantElementsFilterProps> = ({
    show,
    onHide,
    caseworkerOptions,
    selectedCaseworkerIds,
    onCaseworkerChange,
    waiverOptions,
    selectedWaiverIds,
    onWaiverChange,
    regionOptions,
    selectedRegionId,
    onRegionChange,
    selectedEmailLinked,
    onEmailLinkedChange,
    onReset,
    onApply, // Destructure onApply
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end" className="custom_popup">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Filters</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="mb-3">
                    <Form.Group controlId="caseworkerSelect">
                        <Form.Label className="fw-semibold">Caseworker</Form.Label>
                        <div className="hover-text-black">
                            <Select
                                isMulti
                                options={caseworkerOptions}
                                value={caseworkerOptions.filter(opt => selectedCaseworkerIds.includes(opt.value))}
                                onChange={(selected) => onCaseworkerChange(selected ? selected.map((s: any) => s.value) : [])}
                                classNamePrefix="react-select"
                                placeholder="Select caseworker(s)"
                            />
                        </div>
                       
                    </Form.Group>
                </div>

                <div className="mb-3">
                    <Form.Group controlId="waiverSelect">
                        <Form.Label className="fw-semibold">Participant Waiver</Form.Label>
                        <div className="hover-text-black">
                              <Select
                            isMulti
                            options={waiverOptions}
                            value={waiverOptions.filter(opt => selectedWaiverIds.includes(opt.value))}
                            onChange={(selected) => onWaiverChange(selected ? selected.map((s: any) => s.value) : [])}
                            classNamePrefix="react-select"
                            placeholder="Select waiver(s)"
                        />
                        </div>
                      
                    </Form.Group>
                </div>

                <div className="mb-3">
                    <Form.Group controlId="regionSelect">
                        <Form.Label className="fw-semibold">Region</Form.Label>
                        <Form.Select
                            size="sm"
                            value={selectedRegionId?.toString() ?? ""}
                            onChange={(e) => onRegionChange(e.target.value)}
                        >
                            <option key="all" value="">All</option>
                            {regionOptions.map((r) => (
                                <option key={r.value} value={r.value}>
                                    {r.label}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </div>

                <div className="mb-3">
                    <Form.Group controlId="emailLinkedSelect">
                        <Form.Label className="fw-semibold">Email Linked</Form.Label>
                        <Form.Select
                            size="sm"
                            value={selectedEmailLinked}
                            onChange={(e) => onEmailLinkedChange(e.target.value)}
                        >
                            <option value="">All</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                        </Form.Select>
                    </Form.Group>
                </div>

                <div className="d-flex justify-content-end">
                    <Button
                        variant="secondary"
                        size="sm"
                        className="me-2"
                        onClick={onReset}
                    >
                        Reset
                    </Button>
                    <Button variant="primary" size="sm" onClick={onApply}>
                        Apply
                    </Button>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ParticipantElementsFilter;